import { IonLoading } from '@ionic/react';
import React from 'react';

export function Loading () {
  return (<IonLoading isOpen={true} message={'Please wait...'}/>);
}
